import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight, Sparkles } from "lucide-react";

export const CompletionCard = ({ pct = 100, missing = [], editTo = "#" }) => {
  const done = pct >= 100 || (missing || []).length === 0;
  const tone = pct >= 80 ? "emerald" : pct >= 50 ? "amber" : "rose";
  const bar = { emerald: "bg-emerald-500", amber: "bg-amber-500", rose: "bg-rose-500" }[tone];
  const txt = { emerald: "text-emerald-700", amber: "text-amber-600", rose: "text-rose-600" }[tone];
  return (
    <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-5" data-testid="completion-card">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading font-bold text-lg flex items-center gap-2">
          <Sparkles size={18} className="text-violet-600" /> Complétude de votre fiche
        </h2>
        <span className={`font-extrabold text-xl ${txt}`} data-testid="completion-pct">{pct}%</span>
      </div>
      <div className="mt-3 h-2.5 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full ${bar} transition-all`} style={{ width: `${pct}%` }} />
      </div>
      {done ? (
        <div className="mt-4 flex items-center gap-2 text-sm font-semibold text-emerald-700" data-testid="completion-done">
          <CheckCircle2 size={18} /> Votre fiche est complète. Bravo !
        </div>
      ) : (
        <>
          <p className="mt-4 text-sm text-slate-500">Complétez ces éléments pour gagner en visibilité :</p>
          <ul className="mt-2 divide-y divide-slate-100 border border-slate-100 rounded-xl overflow-hidden">
            {(missing || []).map((m, i) => (
              <li key={i}>
                <Link to={editTo} className="flex items-center gap-3 p-3 hover:bg-slate-50 transition-colors" data-testid={`completion-missing-${i}`}>
                  <Circle size={16} className="text-slate-300 shrink-0" />
                  <span className="flex-1 text-sm font-medium text-slate-700 first-letter:uppercase">{m}</span>
                  <ArrowRight size={15} className="text-slate-400 shrink-0" />
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
